/*
 * Newsletter Neosyntis: zapis z rabatem (okno, sekcja nad stopką, koszyk).
 * Konfiguracja w window.NSS_NL (layout/theme.liquid, ustawienia motywu „Newsletter”).
 *
 * Zapis:
 *   1. Formularz 'customer' Shopify (klient z tagami newsletter, nl-<miejsce>) z niewidzialną
 *      hCaptchą Shopify. Używamy natywnego wysłania i przekierowania Shopify.
 *      Po powrocie z ?customer_posted=true zapis dokańcza resume() (nss-nl-pending).
 *   2. MailerLite, grupa „Sklep: nowi zapisani” (maile powitalne), no-cors + keepalive.
 *   3. Kod w koszyku: /discount/<kod> (ciasteczko, działa też przy pustym koszyku)
 *      i /cart/update.js {discount} (od razu na koszyku). Nie nadpisujemy innego,
 *      ważnego kodu, który klient już ma.
 */
(function () {
  'use strict';

  var C = window.NSS_NL || {};
  var CODE = String(C.code || 'WITAJ10').toUpperCase();
  var PCT = C.pct || 10;
  var K_SUB = 'nss-nl-sub';
  var K_CLOSED = 'nss-nl-pop-closed';
  var K_TAB = 'nss-nl-tab-closed';
  var K_SHOWN = 'nss-nl-pop-shown';
  var K_PENDING = 'nss-nl-pending';
  var K_PENDING_EMAIL = 'nss-nl-pending-email';
  var DAY = 864e5;
  var NB = ' ';

  function store(kind) {
    try { var s = window[kind]; var t = '__nl'; s.setItem(t, t); s.removeItem(t); return s; } catch (e) { return null; }
  }
  var LS = store('localStorage');
  var SS = store('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) {} }
  function del(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }

  function isSub() { return !!C.subscribed || get(LS, K_SUB) === '1'; }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  /* ---------- zapis ---------- */

  function formFor(root) {
    var id = root.getAttribute('data-nl-form');
    return id ? document.getElementById(id) : root.querySelector('form.nl__form');
  }

  function toMailerLite(email) {
    if (!C.ml) return;
    try {
      var b = new URLSearchParams();
      b.set('fields[email]', email);
      b.set('ml-submit', '1');
      b.set('anticsrf', 'true');
      fetch(C.ml, {
        method: 'POST', mode: 'no-cors', keepalive: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: b.toString()
      });
    } catch (e) {}
  }

  function cartJson() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function applyCode() {
    return cartJson()
      .then(function (cart) {
        var other = (cart.discount_codes || []).filter(function (d) {
          return d.applicable && String(d.code).toUpperCase() !== CODE;
        })[0];
        if (other) return { kept: other.code };
        return fetch('/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
          .then(function () {
            if (!cart.item_count) return { reserved: true, empty: true };
            return fetch('/cart/update.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: CODE })
            }).then(function (response) { return response.json(); }).then(function (updatedCart) {
              var applied = (updatedCart.discount_codes || []).some(function (discount) {
                return discount.applicable && String(discount.code).toUpperCase() === CODE;
              });
              return { reserved: true, applied: applied };
            });
          });
      })
      .catch(function () { return {}; });
  }

  /* ---------- widok ---------- */

  function showError(root, msg) {
    var err = root.querySelector('[data-nl-error]');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }
  function hideError(root) {
    var err = root.querySelector('[data-nl-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
  }

  function showDone(root, res, opts) {
    opts = opts || {};
    var formState = root.querySelector('.nl__form-state');
    var done = root.querySelector('[data-nl-done]');
    var note = root.querySelector('[data-nl-note]');
    var apply = root.querySelector('[data-nl-apply]');
    if (formState) formState.hidden = true;
    if (done) done.hidden = false;
    root.setAttribute('data-state', 'done');
    if (note) {
      if (opts.returning) {
        note.textContent = 'Kod daje ' + PCT + '% rabatu dla subskrybentów. Przy zakupie użyj adresu e-mail z zapisu. Obowiązuje raz na klienta.';
      } else if (res && res.kept) {
        note.textContent = 'W' + NB + 'koszyku masz już kod ' + res.kept + ', więc go zostawiamy. Kod ' + CODE +
          ' wykorzystasz po podaniu adresu e-mail z zapisu. Obowiązuje raz na klienta.';
      } else {
        note.textContent = 'Przy zakupie podaj ten sam adres e-mail co przy zapisie. Shopify sprawdzi subskrypcję i naliczy ' + PCT + '% rabatu. Kod działa raz na klienta.';
      }
    }
    if (apply) apply.hidden = !opts.returning;
    root.dispatchEvent(new CustomEvent('nl:done', { bubbles: true, detail: { res: res || {}, returning: !!opts.returning } }));
    if (done && opts.focus) { try { done.focus({ preventScroll: true }); } catch (e) {} }
  }

  function copyCode(btn) {
    function ok() {
      var t = btn.textContent;
      btn.textContent = 'Skopiowano';
      setTimeout(function () { btn.textContent = t; }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(CODE).then(ok, function () {});
      return;
    }
    try {
      var ta = document.createElement('textarea');
      ta.value = CODE; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); ok();
    } catch (e) {}
  }

  function bind(root) {
    var form = formFor(root);
    var input = root.querySelector('.nl__input');
    var btn = root.querySelector('.nl__submit');
    var variant = root.getAttribute('data-nl-variant') || 'section';
    var label = btn ? btn.textContent : '';
    var watchdog = null;

    function busy(on) {
      if (on) {
        root.setAttribute('aria-busy', 'true');
        if (btn) { btn.disabled = true; btn.textContent = 'Zapisuję…'; }
      } else {
        root.removeAttribute('aria-busy');
        if (btn) { btn.disabled = false; btn.textContent = label; }
        clearTimeout(watchdog);
      }
    }
    function fail(msg) {
      busy(false);
      if (form) { form.__nlGo = false; form.__nlActive = false; }
      del(SS, K_PENDING);
      del(SS, K_PENDING_EMAIL);
      showError(root, msg || 'Nie udało się zapisać. Spróbuj jeszcze raz za chwilę.');
    }
    if (form) {
      // Use Shopify's native protected submission and resume only after
      // the server redirects back with customer_posted=true.
      // Keep the submit button enabled while Shopify obtains its token.
      form.addEventListener('submit', function (e) {
        if (form.__nlGo) return;
        var email = (input && input.value || '').trim();
        if (!validEmail(email)) {
          e.preventDefault();
          showError(root, 'Wpisz poprawny adres e-mail.');
          if (input) input.focus();
          return;
        }
        if (input) input.value = email;
        hideError(root);
        form.__nlGo = true;
        set(SS, K_PENDING, variant);
        set(SS, K_PENDING_EMAIL, email);
        root.setAttribute('aria-busy', 'true');
        watchdog = setTimeout(function () {
          if (root.getAttribute('aria-busy') === 'true') fail();
        }, 25000);
      }, true);
    }

    root.addEventListener('click', function (e) {
      var copy = e.target.closest('[data-nl-copy]');
      if (copy) { e.preventDefault(); copyCode(copy); return; }
      var apply = e.target.closest('[data-nl-apply]');
      if (apply) {
        e.preventDefault();
        apply.disabled = true;
        applyCode().then(function (res) {
          if (res && res.applied) { window.location.reload(); return; }
          apply.disabled = false;
          showDone(root, res, {});
        });
      }
    });

    // Błąd z serwera (zapis bez JS) zostaje widoczny, pozostałe stany zaczynają od formularza.
    if (isSub() && variant !== 'popup' && !root.querySelector('[data-nl-server-error]')) {
      showDone(root, {}, { returning: true });
    }
  }

  /* ---------- okno ---------- */

  function bannerOpen() {
    var el = document.getElementById('shopify-pc__banner') || document.querySelector('[id^="shopify-pc__banner"]');
    if (el && el.offsetParent !== null) return true;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner());
    } catch (e) { return false; }
  }

  function otherModalOpen() {
    var amb = document.querySelector('.amb-modal');
    return !!(amb && !amb.hidden && amb.offsetParent !== null);
  }

  function initPopup() {
    var pop = document.querySelector('[data-nl-pop]');
    var tab = document.querySelector('[data-nl-tab]');
    if (!pop) return null;
    var box = pop.querySelector('.nl-pop__box');
    var root = pop.querySelector('[data-nl]');
    var lastFocus = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;

    function focusables() {
      return Array.prototype.filter.call(
        box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function showTab() {
      if (!tab || isSub()) return;
      var t = parseInt(get(LS, K_TAB), 10) || 0;
      if (Date.now() - t < 7 * DAY) return;
      tab.hidden = false;
    }

    function open() {
      if (pop.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      pop.hidden = false;
      if (tab) tab.hidden = true;
      document.documentElement.classList.add('nl-lock');
      set(SS, K_SHOWN, '1');
      document.addEventListener('keydown', onKey);
      requestAnimationFrame(function () {
        pop.classList.add('is-open');
        var input = pop.querySelector('.nl__input');
        var target = pop.getAttribute('data-state') === 'done' ? pop.querySelector('[data-nl-done]') : (touch ? box : input);
        if (target) { try { target.focus({ preventScroll: true }); } catch (e) {} }
      });
    }

    function close() {
      if (pop.hidden) return;
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('nl-lock');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { pop.hidden = true; }, reduce ? 0 : 220);
      if (!isSub()) {
        set(LS, K_CLOSED, String(Date.now()));
        showTab();
      }
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    box.setAttribute('tabindex', '-1');
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-nl-pop-close]')) { e.preventDefault(); close(); }
    });
    // Po zapisie przycisk „Wybierz suplementy” na stronie kolekcji tylko zamyka okno.
    var go = pop.querySelector('[data-nl-pop-go]');
    if (go) go.addEventListener('click', function (e) {
      if (window.location.pathname.indexOf('/collections/') === 0 || window.location.pathname.indexOf('/products/') === 0) {
        e.preventDefault(); close();
      }
    });
    if (root) root.addEventListener('nl:done', function () { pop.setAttribute('data-state', 'done'); if (tab) tab.hidden = true; });

    if (tab) {
      tab.addEventListener('click', function (e) {
        if (e.target.closest('[data-nl-tab-close]')) {
          tab.hidden = true;
          set(LS, K_TAB, String(Date.now()));
          return;
        }
        if (e.target.closest('[data-nl-tab-open]')) open();
      });
    }

    var api = { open: open, close: close };

    if (isSub()) return api;

    var closedAt = parseInt(get(LS, K_CLOSED), 10) || 0;
    if (Date.now() - closedAt < 7 * DAY) { showTab(); return api; }
    if (get(SS, K_SHOWN) === '1') { showTab(); return api; }

    // Wyzwalacze: czas, połowa strony, kursor wychodzący z okna (desktop).
    // Okno czeka na decyzję o cookies, maksymalnie 30 s.
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onLeave);
      var tries = 0;
      (function wait() {
        if (!bannerOpen() && !otherModalOpen()) { open(); return; }
        if (++tries > 60) return;
        setTimeout(wait, 500);
      })();
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.5) fire();
    }
    function onLeave(e) {
      if (!e.relatedTarget && e.clientY <= 0) fire();
    }
    var delay = Math.max(3, parseInt(C.delay, 10) || 8) * 1000;
    setTimeout(fire, delay);
    setTimeout(function () {
      if (fired) return;
      window.addEventListener('scroll', onScroll, { passive: true });
      if (!touch) document.addEventListener('mouseout', onLeave);
    }, 2500);

    return api;
  }

  /* ---------- powrót po captchy Shopify ---------- */

  function resume(popup) {
    var pending = get(SS, K_PENDING);
    if (!pending) return;
    if (window.location.search.indexOf('customer_posted=true') < 0) return;
    var confirmedEmail = get(SS, K_PENDING_EMAIL);
    if (confirmedEmail && validEmail(confirmedEmail)) toMailerLite(confirmedEmail);
    del(SS, K_PENDING);
    del(SS, K_PENDING_EMAIL);
    set(LS, K_SUB, '1');
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (e) {}
    applyCode().then(function (res) {
      if (pending === 'cart' && res && res.applied) { window.location.reload(); return; }
      var root = document.querySelector('[data-nl][data-nl-variant="' + pending + '"]') ||
                 document.querySelector('[data-nl-pop] [data-nl]') ||
                 document.querySelector('[data-nl]');
      if (!root) return;
      showDone(root, res, {});
      if (root.closest('[data-nl-pop]') && popup) popup.open();
      else root.scrollIntoView({ block: 'center' });
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-nl]');
    Array.prototype.forEach.call(roots, bind);

    // Koszyk: po naliczeniu kodu przeładowanie pokazuje nową sumę.
    document.addEventListener('nl:done', function (e) {
      var root = e.target;
      if (root.getAttribute('data-nl-variant') !== 'cart') return;
      var d = e.detail || {};
      if (d.res && d.res.applied && !d.res.empty && !d.returning) {
        var note = root.querySelector('[data-nl-note]');
        if (note) note.textContent = 'Rabat ' + PCT + '% naliczony. Przeliczam koszyk…';
        setTimeout(function () { window.location.reload(); }, 1200);
      }
    });

    var popup = initPopup();
    resume(popup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
